/** Open work items of one domain or registrant, linked from their pages. */

import { Inbox } from 'lucide-react';
import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';
import { api } from '@/api';
import { Callout } from '@/components/blocks';
import { useApi } from '@/lib/useApi';

export function LinkedWork({ domainId, subjectId, empty }: { domainId?: string; subjectId?: string; empty?: ReactNode }) {
  const { t } = useTranslation('work');
  const result = useApi(
    (signal) => api.listWorkItems({ status: 'OPEN', domain_id: domainId, subject_id: subjectId, limit: 50 }, { signal }),
    [domainId, subjectId],
  );
  // Without work_item.read (or while loading) nothing is shown: this is a pointer, not a page.
  if (result.status !== 'success') return null;
  if (result.data.items.length === 0) return empty ?? null;
  const n = result.data.items.length;
  const q = domainId ? `domain_id=${encodeURIComponent(domainId)}` : `subject_id=${encodeURIComponent(subjectId ?? '')}`;
  return (
    <Callout tone="warn" title={t('linked.title')}>
      <span className="inline-flex flex-wrap items-center gap-2">
        <Inbox className="size-4" aria-hidden="true" />
        {t('linked.open', { count: n })} ·{' '}
        <Link to={`/compliance/work?${q}`} className="font-medium text-primary hover:underline">
          {t('linked.view')}
        </Link>
      </span>
    </Callout>
  );
}
